export const ReferenciaDTO=
{
    UbicacionPreferencia:"0",
    UbicacionHistorial:"1",
    UbicacionCarga:"2",
    UbicacionPagoPendiente:"3",
    UbicacionPrepago:"4",
    UbicacionEntrega:"5",
    UbicacionActualizar:"6",
    UbicacionPreAlerta:"7",
    UbicacionActualizarDomicilio:"8",
    UbicacionCalculadora:"9",
    UbicacionSinFactura:"10",
    UbicacionCupones:"11",
    UbicacionDocumentacion:"12",
    UbicacionVendemosContigo:"13",
    UbicacionHistorialPuntos:"14",
    UbicacionAmigoReferido:"15",
}